import React from "react";
import LegalLayout from "../components/LegalLayout";

/**
 * Privacy policy stub — written in plain language, accurate to what the
 * product actually does. Owned by Zephiron Group LLC.
 *
 * This is a STARTING POINT, not legal advice. Have counsel review before
 * promoting widely or going live with paid plans.
 */
const SECTIONS = [
    {
        heading: "who we are",
        body: [
            "MoodCard is a product of Zephiron Group LLC, a Wyoming, USA limited liability company (\"Zephiron\", \"we\", \"us\"). MoodCard is a service that turns short text describing how you're feeling into three shareable cards.",
        ],
    },
    {
        heading: "what we collect",
        body: [
            "The text of feelings you submit (so we can generate cards for you and show you your history).",
            "Anonymous browser identifiers stored in localStorage (so a recipient reloading a shared link doesn't count as a new open).",
            "If you sign in: your email address, display name, and profile picture from Google or Apple — only what those providers expose during sign-in.",
            "Standard server logs: IP address, user agent, and timestamps. Retained for security and reliability for up to 90 days.",
            "Optional, opt-in: an email address you provide if you choose to receive daily \"pulse\" prompts.",
        ],
    },
    {
        heading: "what we do not collect",
        body: [
            "We do not collect contacts, location data, ad identifiers, or biometric information.",
            "We do not track you across other apps or websites.",
            "We do not sell, rent, or share your data with advertisers — full stop.",
        ],
    },
    {
        heading: "how we use what you give us",
        body: [
            "To generate cards (we send the feeling text to a language model on your behalf — currently Anthropic Claude via Emergent's universal key).",
            "To show you your card history, recent shares, and recipients who have opened your shared cards.",
            "To process payments through Stripe if and when you upgrade to a paid plan.",
            "To send transactional or pulse emails through Resend if you opt in.",
            "To monitor service health and prevent abuse.",
        ],
    },
    {
        heading: "third parties we share data with",
        body: [
            "Anthropic / Emergent — to generate card variants from your feeling text. Bound by Emergent's data-handling terms.",
            "Stripe — to process payments. Stripe holds card information directly; we never see your full card number.",
            "Resend — to send transactional emails. They only see the email address you opted in with.",
            "MongoDB Atlas hosting our database. Standard cloud-provider arrangement.",
            "Google / Apple — for sign-in only, and only when you choose to use them.",
        ],
    },
    {
        heading: "how long we keep things",
        body: [
            "Cards: indefinitely while your account exists. Email us at hello@moodcard.app to request deletion.",
            "Sessions: 30 days after last activity.",
            "Server logs: up to 90 days.",
        ],
    },
    {
        heading: "your rights",
        body: [
            "Request a copy of your data, request deletion, or request correction: email hello@moodcard.app and we will respond within 30 days.",
            "If you're in the EU/UK, you can also lodge a complaint with your local data-protection authority.",
            "If you're in California, you have rights under the CCPA. We do not \"sell\" personal information as that term is defined under the CCPA.",
        ],
    },
    {
        heading: "children",
        body: [
            "MoodCard is not directed to children under 13. If you believe a child has provided us with information, please contact us and we will remove it.",
        ],
    },
    {
        heading: "changes to this policy",
        body: [
            "We'll update the \"last updated\" date above any time we make a meaningful change. For significant changes we'll also email signed-in users.",
        ],
    },
    {
        heading: "contact",
        body: [
            "Zephiron Group LLC — Wyoming, USA. Reach us at hello@moodcard.app.",
        ],
    },
];

export default function Privacy() {
    return (
        <LegalLayout
            title="Privacy"
            subtitle="how we treat what you say here"
            lastUpdated="March 4, 2026"
            sections={SECTIONS}
            testid="privacy-screen"
        />
    );
}
